export default "__VITE_ASSET__DykUE8Bq__"